<template>
  <div>
    <h1>Jim Border</h1>
    <p>You already know Jim is Co-founder, creative strategist, and problem solver extraordinaire.</p>
    <img src="@/assets/jim.png" alt="Jim" class="jim-thumbnail" />
  </div>
</template>

<script setup lang="ts">
</script>

<style scoped>
.jim-thumbnail {
  border-radius: 50%;
  width: 200px;
}
</style>